import { Fragment, useState, useEffect } from 'react'
import callApi from '../../helpers/callapi'
import CONSTANTS from '../../constants/constants'
import { useDispatch } from 'react-redux'
import { Form, Card, Dropdown, Row, Col, Table } from 'react-bootstrap'
import Pagination from '../../components/Nav/Pagination'

const Logs = () => {
  const [logs, setLogs] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [searchText, setSearchText] = useState('')
  const [type, setType] = useState('all')
  const [forceUpdate, setForceUpdate] = useState(false)
  const dispatch = useDispatch()

  const fetchLogs = async (page = currentPage, _searchText = searchText, _type = type) => {
    try {
      dispatch({ type: 'loading_show' })
      const query = {
        name: _searchText,
      }
      if (_type !== 'all') {
        query.type = _type
      }
      if (page) {
        query.page = page
      }
      const { results: logs } = await callApi({
        url: '/logs',
        query,
      })
      setLogs(logs)
      dispatch({ type: 'loading_hide' })
    } catch (error) {
      setLogs([])
      dispatch({ type: 'loading_hide' })
    }
  }

  useEffect(() => {
    fetchLogs()
    setCurrentPage(1)
  }, [forceUpdate])

  const onChangePage = (page) => {
    setCurrentPage(page)
    fetchLogs(page)
  }

  const handleOnChange = (e) => {
    e.preventDefault()
    fetchLogs(1, e.target.value)
  }

  const displayDropdown = () => {
    return (
      <Form>
        <Row>
          <b style={{ marginTop: '17px', marginLeft: '20px' }}>Type:</b>
          <Col sm={12} md={6} lg={4}>
            <Dropdown>
              <select
                className="form-control"
                style={{ color: '#5d5d5d' }}
                onChange={(value) => {
                  setType(value.target.value)
                  fetchLogs(1, undefined, value.target.value)
                }}
              >
                <option value="all">ทั้งหมด</option>
                {CONSTANTS.logs.map((logType, i) => {
                  return (
                    <option key={i} value={logType.value}>
                      {logType.label}
                    </option>
                  )
                })}
              </select>
            </Dropdown>
          </Col>
        </Row>
      </Form>
    )
  }

  const displaySearch = () => {
    return (
      <Form>
        <Row>
          <Col sm={12} md={6} lg={12}>
            <div className="d-flex pt-2 pb-2">
              <input
                type="text"
                placeholder="ชื่อผู้ดูแลระบบ"
                className="form-control mr-2"
                style={{ color: '#5d5d5d' }}
                onChange={(e) => setSearchText(e.target.value)}
                onKeyDown={(e) => {
                  if (e.code === 'Enter') {
                    handleOnChange(e)
                  }
                }}
              />
              <div
                className="btn btn-primary light"
                style={{ minWidth: '120px' }}
                onClick={() => setForceUpdate(!forceUpdate)}
              >
                ค้นหา
              </div>
            </div>
          </Col>
        </Row>
      </Form>
    )
  }

  const displayTableLog = () => {
    return (
      <Table responsive striped bordered className="verticle-middle">
        <thead>
          <tr>
            <th style={{ width: '30%' }}>วัน/เวลา</th>
            <th>คำอธิบาย</th>
          </tr>
        </thead>
        <tbody>
          {logs.map((log, i) => {
            return (
              <tr key={i}>
                <td>{new Date(log.createdAt).toLocaleString('th-TH')}</td>
                <td>{log.description}</td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    )
  }

  return (
    <Fragment>
      <Card>
        <Card.Header>
          <Card.Title>Logs</Card.Title>
        </Card.Header>
        <Card.Body>
          {displayDropdown()}
          <br />
          {displaySearch()}
          <br />
          {displayTableLog()}
          <Pagination
            currentPage={currentPage}
            onPrevPage={() => onChangePage(currentPage - 1)}
            onNextPage={() => onChangePage(currentPage + 1)}
            items={logs}
            perPage={100}
          />
        </Card.Body>
      </Card>
    </Fragment>
  )
}
export default Logs
